import Button from '@components/v2/ui/Button/Button';
import Icon from '@components/v2/ui/Icon/Icon';
import { Download } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

interface DownloadCsvButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
  testId?: string;
}

const DownloadCsvButton = ({ onClick, isDisabled, testId }: DownloadCsvButtonProps) => {
  const { translate } = useTranslation();

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      onClick={onClick}
      disabled={isDisabled}
      testId={testId}
      startIcon={<Icon icon={Download} size="xs" />}
    >
      {translate(LangEnum.GLOBAL_DOWNLOAD_CSV)}
    </Button>
  );
};

DownloadCsvButton.displayName = 'DownloadCsvButton';
export type { DownloadCsvButtonProps };
export default DownloadCsvButton;
